import React from 'react'
import './post.css'

function PostSkeleton() {
    return (
        <div className="post">
            <h2 className="post-title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h2>
            <div className="post-info">
                <span></span>
                <span></span>
            </div>
            <p className="post-desc">                
                               
            </p>
            <ul className="post-tags">
                     
            </ul>
        </div>
    )
}

export default PostSkeleton
